import "./Home.css";

import React, { useEffect, useState } from "react";
import { Container, Grid, Box, Typography, Stack, Button } from "@mui/material";
import { useTheme } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import { CardBox } from "../../components/card-box/CardBox";
import { Section } from "../../layouts/landing-page/Section";

import ghostCompassImage from "../../assets/images/ghost-compass.jpg";
import ghostCompassTopImage from "../../assets/images/ghost-compass-top.png";
import { Discovery } from "../../types";
import { DiscoveryCard } from "../../components/discovery-card/DiscoveryCard";

const mockData: Discovery[] = [
  {
    contractHash: "CH_AAAAA-AAAAA-AAAAA-AAAAA", //
    blockId: "BID_AAAAA-AAAAA-AAAAA-AAAAA",
    developer: "DEV_AAAAA-AAAAA-AAAAA-AAAAA",
    avatar: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6",
  },
  {
    contractHash: "CH_BBBBB-BBBBB-BBBBB-BBBBB", //
    blockId: "BID_BBBBB-BBBBB-BBBBB-BBBBB",
    developer: "DEV_BBBBB-BBBBB-BBBBB-BBBBB",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9",
  },
  {
    contractHash: "CH_CCCCC-CCCCC-CCCCC-CCCCC", //
    blockId: "BID_CCCCC-CCCCC-CCCCC-CCCCC",
    developer: "DEV_CCCCC-CCCCC-CCCCC-CCCCC",
    avatar: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
  },
];

async function fetchDiscoveries(
  setData: React.Dispatch<React.SetStateAction<Discovery[]>>,
  setError: React.Dispatch<React.SetStateAction<string>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) {
  setError("");
  setLoading(true);

  setData(mockData);

  setTimeout(() => {
    setLoading(false);
  }, 2000);
}

type HomeProps = {};

export const Home: React.FC<HomeProps> = () => {
  const [data, setData] = useState<Discovery[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const theme = useTheme();

  useEffect(() => {
    fetchDiscoveries(setData, setError, setLoading);
  }, []);

  return (
    <Container maxWidth={false} disableGutters sx={{ position: "relative" }}>
      <Section maxWidth={"md"}>
        <Grid container spacing={2} sx={{ mt: "1rem" }}>
          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
            <Typography variant={"h1"} component={"h1"} textAlign={"center"}>
              Smart Contract Tracker
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "flex" } }}>
            <Box sx={{ width: "100%", overflow: "hidden", borderTopLeftRadius: "3rem", borderBottomLeftRadius: "3rem" }}>
              <img src={ghostCompassTopImage} style={{ width: "100%", height: "auto", display: "block" }} alt="ghost-compass" />
            </Box>
          </Grid>
        </Grid>
        <CardBox color={"none"} noBackground sx={{ mb: 5, p: 0, mt: { xs: "2rem", md: "0rem" } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2, height: "100%", p: "1.5rem" }}>
                <Typography variant={"h4"} component={"p"} textAlign={"center"} sx={{ textWrap: "balance" }}>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam, tenetur id voluptatibus quasi obcaecati tempore.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "flex" } }}>
              <Box sx={{ width: "100%", overflow: "hidden", borderTopLeftRadius: "0rem", borderBottomLeftRadius: "8rem" }}>
                <img src={ghostCompassImage} style={{ width: "100%", height: "auto", display: "block" }} alt="ghost-compass" />
              </Box>
            </Grid>
          </Grid>
        </CardBox>
      </Section>

      <Section maxWidth={"md"}>
        <CardBox color={"secondary"} sx={{ mb: 5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
                <Typography component={"p"} variant={"h2"} sx={{ mb: theme.spacing(1) }}>
                  <Typography component={"span"} variant={"h2"} color={"primary"}>
                    Contract
                  </Typography>{" "}
                  Discovery
                </Typography>
                <Button
                  variant="contained"
                  color={"primary"}
                  startIcon={<RefreshIcon />}
                  onClick={loading ? () => {} : () => fetchDiscoveries(setData, setError, setLoading)}
                  className={loading ? "animate-refresh-icon" : ""}
                >
                  Refresh
                </Button>
              </Stack>
            </Grid>

            {loading && (
              <Typography variant={"h1"} textAlign={"center"} sx={{ fontWeight: 100, width: "100%", py: "5rem" }} className="pulse-animation">
                DISCOVERING CONTRACTS...
              </Typography>
            )}

            {!loading && error && (
              <Typography variant={"h1"} textAlign={"center"} sx={{ fontWeight: 100, width: "100%", py: "5rem" }}>
                Ups! Something went wrong...
              </Typography>
            )}

            {!loading && !error && data.length === 0 && (
              <Typography variant={"h1"} textAlign={"center"} sx={{ fontWeight: 100, width: "100%", py: "5rem" }}>
                No data has been found.
              </Typography>
            )}

            {!loading &&
              !error &&
              data.length > 0 &&
              mockData.map((item) => {
                return (
                  <Grid item xs={12} md={6}>
                    <DiscoveryCard data={item} />
                  </Grid>
                );
              })}
          </Grid>
        </CardBox>
      </Section>
    </Container>
  );
};
